var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('email-verification-modal',{attrs:{"email-info":_vm.emailInfo,"is-change":_vm.isChange,"initial-verify-id":_vm.verifyId,"initial-pin-code":_vm.pinCode},on:{"close":_vm.handleClose}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }